/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SchoolSubscriptionTransportCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, SchoolSubscTransportDto } from "../models";

@Injectable({ providedIn: "root" })
export class SchoolSubscriptionTransportCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    getSubscriptionTransportByPartner(idSchool: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<SchoolSubscTransportDto>>;
    getSubscriptionTransportByPartner(idSchool: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<SchoolSubscTransportDto>>>;
    getSubscriptionTransportByPartner(idSchool: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<SchoolSubscTransportDto>>>;
    getSubscriptionTransportByPartner(idSchool: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/transports`;

        let params = new HttpParams();
        if (idSchool != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idSchool, 'idSchool');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    addSubscriptionTransport(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    addSubscriptionTransport(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    addSubscriptionTransport(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    addSubscriptionTransport(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/transports`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: schoolSubscTransportDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    update(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    update(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    update(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    update(schoolSubscTransportDto: SchoolSubscTransportDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/transports`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('put', url, {
            body: schoolSubscTransportDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    deleteTransport(idTransport: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteTransport(idTransport: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteTransport(idTransport: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteTransport(idTransport: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/schools/subscriptions/transports`;

        let params = new HttpParams();
        if (idTransport != null) {
            params = HttpParamsBuilder.addToHttpParams(params, idTransport, 'idTransport');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('delete', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
